<button
  *ngIf="showDropdownButton && !oneNumberToRuleThemAll"
  data-cy="call-btn"
  [disabled]="isCallButtonDisabled$ | async"
  [matMenuTriggerFor]="call"
  color="primary"
  mat-stroked-button>
  <mat-icon class="call-button-phone-icon">phone</mat-icon>
  Call
  <mat-icon class="arrow-button-icon">arrow_drop_down</mat-icon>
</button>
<button
  *ngIf="!showDropdownButton && oneNumberToRuleThemAll"
  [disabled]="isCallButtonDisabled$ | async"
  color="primary"
  mat-stroked-button
  (click)="callBorrower(firstAvailablePhone)">
  <mat-icon class="call-button-phone-icon">phone</mat-icon>
  Call
</button>
<button
  *ngIf="!showDropdownButton && !oneNumberToRuleThemAll"
  [disabled]="isCallButtonDisabled$ | async"
  color="primary"
  mat-stroked-button>
  <mat-icon class="call-button-phone-icon">phone</mat-icon>
  Call
</button>
<mat-menu #call="matMenu" class="call-menu">
  <p
    *ngIf="borrowerValuePhone && borrowerValuePhone.value"
    class="phone-types-header tw-font-semibold">
    Business
  </p>
  <button
    class="phone-type-btn"
    *ngIf="borrowerValuePhone && borrowerValuePhone.value"
    data-cy="business-phone"
    mat-menu-item
    (click)="callBorrower(borrowerValuePhone.value.toString(), phoneCountryCode.toString())">
    +{{ phoneCountryCode }} {{ borrowerValuePhone.value | phone: phoneCountry }}
  </button>

  <div *ngFor="let contact of joinedContacts$ | async">
    <p class="phone-types-header tw-font-semibold">{{ contact.first }} {{ contact.last }}</p>
    <button
      class="phone-type-btn"
      *ngIf="contact.workPhone"
      mat-menu-item
      (click)="callBorrower(contact.workPhone.toString(), contact.work_phone_country_code.countryCode.toString())">
      <div class="tw-flex">
            <span class="tw-w-14">
              Work:
            </span>
        <span>
              +{{ contact?.work_phone_country_code?.countryCode }} {{ contact?.workPhone | phone: contact?.work_phone_country_code?.country?.countryCode }}
            </span>
      </div>
    </button>
    <button
      class="phone-type-btn"
      *ngIf="contact.mobilePhone"
      mat-menu-item
      (click)="callBorrower(contact.mobilePhone.toString(), contact.mobile_phone_country_code.countryCode.toString())">
      <div class="tw-flex">
            <span class="tw-w-14">
              Mobile:
            </span>
        <span>
              +{{ contact?.mobile_phone_country_code?.countryCode }} {{ contact?.mobilePhone | phone: contact?.mobile_phone_country_code?.country?.countryCode }}
            </span>
      </div>
    </button>
  </div>
</mat-menu>
